import { Component, OnInit, Input } from '@angular/core';
import { GfTitleService } from '../../../../services/core.title.service';
import * as _ from 'lodash';
import { ProjectService } from '../../../../services/project.service';
import { FilterService } from '../../../../services/core.filter.service';
import { StateService } from '@uirouter/angular';
import { ProjectAdminChecksHelper } from './project.admin.checks.service';

@Component({
  selector: 'project-admin-checks',
  template: require('./project.admin.checks.component.html')
})
export class ProjectAdminChecksComponent implements OnInit {
  active = '';
  @Input() project: any;
  paging: any;
  sorting: any;
  sortFields: any;
  filters: any;
  results: any;
  details: any;
  showDetails: boolean;

  constructor(
    private stateService: StateService, 
    
    private titleService: GfTitleService,
    private projectService: ProjectService,
    private filterService: FilterService,
    private projectAdminChecksHelper: ProjectAdminChecksHelper
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'Health Checks');
    const queryParams = this.stateService.params;

    this.paging = this.filterService.getPagingValues(1, 10, queryParams);
    this.sorting = this.filterService.getSortValues('createDate', 'desc', queryParams);
    this.sortFields = this.projectAdminChecksHelper.getSortFields();

    this.filters = {
      main_fields: this.projectAdminChecksHelper.setFiltersFromStateParams(
        this.projectAdminChecksHelper.getBaseFilters(),
        queryParams
      )
    };

    this.loadReports();

    this.showDetails = +queryParams.id > 0;
    if (this.showDetails) {
      this.loadReportDetails(queryParams.unixName, queryParams.id);
    }
  }

  private loadReports(): void {
    this.results = false;
    const paramFields = [
      'id',
      'since',
      'before',
      'range',
      'page_num',
      'page_size',
      'type',
      'sort_field',
      'sort_dir'
    ];
    const queryParams = _.pick(this.stateService.params, paramFields);
    let params = this.filterService.getFetchArgs(
      { section: 'project', refId: this.project.id, type: 'health' },
      queryParams
    );
    delete params.id;
    delete params.unixName;

    this.projectService.getReportResults(this.stateService.params.unixName, params)
      .then(result => {
        this.results = _.get(result, 'items', []);
      })
      .catch(response => {
        console.log(response);
        this.results = [];
      });
  }

  private loadReportDetails(unixName: string, id: any): void {
    this.details = false;
    this.projectService.getReportResult(unixName, id)
      .then(result => {
        this.details = result;
      })
      .catch(response => {
        console.log(response);
        this.details = [];
      });
  }

  onSort(params: any = {}): void {
    const queryParams = this.stateService.params;
    const newParams = {
      sort_field: _.get(params, 'key', queryParams.sort_field),
      sort_dir: _.get(params, 'sortDir', queryParams.sort_dir),
      page_num: 1
    };
    this.stateService.go('.', newParams)
      .then(() => this.loadReports());
  }

  resetFilters(): void {
    this.filters = {
      main_fields: this.projectAdminChecksHelper.getBaseFilters()
    };

    this.sorting = {
      sort_field: 'createDate',
      sort_dir: 'desc'
    };

    this.paging.page_num = 1;

    const newParams = Object.assign(
      {},
      this.sorting,
      this.paging,
      this.filterService.getFilterValues(this.filters.main_fields, true)
    );

    this.stateService.go('.', newParams)
      .then(() => this.loadReports());
  }

  applyFilters(): void {
    const newParams = this.filterService.getFetchArgs(
      { page_num: 1 },
      this.filterService.getFilterValues(this.filters.main_fields)
    );
    this.stateService.go('.', newParams)
      .then(() => this.loadReports());
  }
}
